import { useState, useEffect, useCallback } from 'react';
import api from '../../api';
import Layout from '../../components/Layout';
import stili from '../../components/competenze/stili';
import useAggiornamentoPeriodico from '../../hooks/useAggiornamentoPeriodico';
import { usePuoScrivere } from '../../utils/permessi';
import FormDitta from './FormDitta';

// Ditte dello Scadenziario: sono i clienti dello studio (stessa anagrafica di Parcellazione)
export default function Ditte() {
  const puoScrivere = usePuoScrivere('scadenziario');
  const [ditte, setDitte] = useState([]);
  const [cerca, setCerca] = useState('');
  const [nonSeguite, setNonSeguite] = useState(false);
  const [inModifica, setInModifica] = useState(null);
  const [errore, setErrore] = useState('');

  const carica = useCallback(() => {
    api.get('/scadenze/ditte', { params: { tutte: nonSeguite ? 1 : undefined } }).then(r => setDitte(r.data))
      .catch(err => setErrore(err.response?.data?.errore || 'Errore nel caricamento'));
  }, [nonSeguite]);
  useEffect(() => { carica(); }, [carica]);
  useAggiornamentoPeriodico(carica, { attivo: !inModifica });

  const q = cerca.trim().toLowerCase();
  const filtrate = ditte.filter(d => !q || d.ragione_sociale.toLowerCase().includes(q)
    || (d.codice_azienda ?? d.codice_ditta_paghe ?? '').toLowerCase().includes(q) || (d.codice_fiscale || '').toLowerCase().includes(q));

  return (
    <Layout>
      <div style={stili.topBar}>
        <h2 style={{ margin: 0 }}>Aziende ({filtrate.length})</h2>
        {puoScrivere && <button onClick={() => setInModifica('nuova')} style={stili.btn}>+ Nuova azienda</button>}
      </div>
      {errore && <div style={stili.errore}>{errore}</div>}
      <div style={{ display: 'flex', gap: '0.8rem', marginBottom: '0.8rem', alignItems: 'center', flexWrap: 'wrap' }}>
        <input type="search" placeholder="Cerca per nome, codice azienda o codice fiscale…" value={cerca} onChange={e => setCerca(e.target.value)} style={{ ...stili.input, flex: 1 }} />
        <label style={{ fontSize: '0.88rem', whiteSpace: 'nowrap' }}>
          <input type="checkbox" checked={nonSeguite} onChange={e => setNonSeguite(e.target.checked)} /> Mostra anche le non seguite
        </label>
      </div>
      <div style={{ overflowX: 'auto' }}>
      <table style={stili.table}>
        <thead>
          <tr>
            <th style={stili.th}>Codice azienda (paghe e contabilità)</th>
            <th style={stili.th}>Ragione sociale</th>
            <th style={stili.th}>Codice fiscale</th>
            {puoScrivere && <th style={stili.th}>Azioni</th>}
          </tr>
        </thead>
        <tbody>
          {filtrate.map(d => (
            <tr key={d.id} style={{ ...stili.tr, opacity: d.attivo ? 1 : 0.5 }}>
              <td style={stili.td}>{(d.codice_azienda ?? d.codice_ditta_paghe) || '—'}</td>
              <td style={stili.td}>{d.ragione_sociale}{!d.attivo && <small style={{ color: '#999' }}> (non seguita)</small>}</td>
              <td style={stili.td}>{d.codice_fiscale || '—'}</td>
              {puoScrivere && <td style={stili.td}><button onClick={() => setInModifica(d)} style={stili.btnSmall}>Modifica</button></td>}
            </tr>
          ))}
          {filtrate.length === 0 && <tr><td colSpan={4} style={{ ...stili.td, textAlign: 'center', color: '#999' }}>Nessuna azienda</td></tr>}
        </tbody>
      </table>
      </div>
      {inModifica && (
        <FormDitta
          ditta={inModifica === 'nuova' ? null : inModifica}
          onChiudi={() => setInModifica(null)}
          onSalvato={() => { setInModifica(null); carica(); }}
        />
      )}
    </Layout>
  );
}
